import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Button,
  ButtonGroup,
  FormControl
} from 'react-bootstrap'
import { LeftSidebarView } from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import KanBoIcon from 'components/KanBoIcon'
import Loader from 'components/Loader'
import Tabs from 'components/Tabs'
import SPUserPicker from 'components/SPUserPicker'
import Scrollbars from 'components/Scrollbars'
import HiddenFileInput from 'components/HiddenFileInput'
import { Waypoint } from 'react-waypoint'
import HomeUser from './User'
import Roles from './Roles'
import UserRoles from './UserRoles'
import classes from './Users.module.scss'
import HistoryContext from 'components/App/HistoryContext'
import { Modal } from 'components/Modal'

export class Users extends React.Component {
  static propTypes = {
    leftSidebar: PropTypes.object.isRequired,

    currentUserRoles: PropTypes.object.isRequired,
    mode: PropTypes.array.isRequired,
    keyword: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    lastLoadedId: PropTypes.number,
    isOffice365: PropTypes.bool.isRequired,

    fetchUsers: PropTypes.func.isRequired,
    requestAddUserToKanBo: PropTypes.func.isRequired,
    requestAddUsersFromFileToKanBo: PropTypes.func.isRequired,
    requestActivateUser: PropTypes.func.isRequired,
    requestDeactivateUser: PropTypes.func.isRequired,
    setMode: PropTypes.func.isRequired,
    setKeyword: PropTypes.func.isRequired,
  }

  static contextType = HistoryContext

  state = {
    addingUserToKanBo: false,
    spUsersKeyword: ''
  }

  componentDidMount = () => {
    const { fetchUsers } = this.props

    fetchUsers({
      refresh: true
    })
  }

  componentDidUpdate = (prevProps) => {
    const { mode, keyword, fetchUsers } = this.props

    if (
      mode !== prevProps.mode ||
      keyword !== prevProps.keyword
    ) {
      fetchUsers({
        refresh: true
      })
    }
  }

  componentWillUnmount = () => {
    this.props.setKeyword('')
  }

  setUserPickerRef = (ref) => {
    this.userPickerRef = ref
  }

  showAddUser = () => {
    if (!this.state.addingUserToKanBo) {
      this.setState({
        addingUserToKanBo: true
      })
    }
  }

  closeAddUser = () => {
    if (this.state.addingUserToKanBo) {
      this.setState({
        addingUserToKanBo: false
      })
    }
  }

  handleWaypointEnter = () => {
    const { fetchUsers } = this.props

    fetchUsers()
  }

  handleAddUserClick = () => {
    const users = this.userPickerRef.getSelectedUsers()

    users.forEach(user => this.props.requestAddUserToKanBo({
      loginType: user.logins[0].type,
      loginName: user.logins[0].name,
    }))

    this.closeAddUser()
  }

  handleManageUserGroupClick = () => {
    this.context.push('/userGroups')
  }

  handleManageRolesClick = () => {
    const {
      leftSidebar
    } = this.props

    leftSidebar.push(Roles)
  }

  handleSearchInputChange = (event) => {
    this.props.setKeyword(event.target.value)
  }

  handleAddUserSearchInputChange = (event) => {
    this.setState({
      spUsersKeyword: event.target.value
    })
  }

  handleFileInputChange = (event) => {
    const { requestAddUsersFromFileToKanBo } = this.props

    const files = event.target.files
    const count = files.length

    if (count > 0) {
      const file = files[0]

      const reader = new FileReader()

      reader.onload = function (event) {
        requestAddUsersFromFileToKanBo({
          data: event.target.result
        })
      }

      reader.readAsText(file)
    }
  }

  handleActivateUser = (id) => {
    const {
      requestActivateUser
    } = this.props

    requestActivateUser({
      id
    })
  }

  handleDeactivateUser = (id) => {
    const {
      requestDeactivateUser
    } = this.props

    requestDeactivateUser({
      id
    })
  }

  handleRolesClick = (id) => {
    const {
      leftSidebar
    } = this.props

    leftSidebar.push(() => <UserRoles userId={id} />)
  }

  render () {
    const {
      currentUserRoles,
      mode,
      keyword,
      users,
      loading,
      loaded,
      lastLoadedId,
      isOffice365,
    } = this.props
    const {
      addingUserToKanBo,
      spUsersKeyword
    } = this.state

    const tabs = [{
      id: 'active',
      title: <FormattedMessage id='USERS_ACTIVE' />,
      onSelect: () => {
        this.props.setMode('active')
      }
    }, {
      id: 'inactive',
      title: <FormattedMessage id='USERS_INACTIVE' />,
      onSelect: () => {
        this.props.setMode('inactive')
      }
    }]

    const menu = []

    if (!isOffice365 || currentUserRoles['setup']) {
      menu.push({
        icon: <KanBoIcon name='kanbo-16-members' />,
        title: <FormattedMessage id='USER_GROUP_MANAGE' />,
        onClick: this.handleManageUserGroupClick
      })
    }

    if (currentUserRoles['role-manage']) {
      menu.push({
        icon: <KanBoIcon name='kanbo-16-user-role' />,
        title: <FormattedMessage id='USER_ROLES_MANAGE' />,
        onClick: this.handleManageRolesClick
      })
    }

    return (
      <React.Fragment>
        <LeftSidebarView
          title={<FormattedMessage id='USERS_HEADER' />}
          buttons={currentUserRoles['user-add'] && [[{
            icon: <KanBoIcon name='kanbo-16-plus' />,
            title: <FormattedMessage id='USERS_ADD' />,
            onClick: this.showAddUser
          }, {
            componentClass: 'div',
            icon: <KanBoIcon name='kanbo-16-add-user-from-file' />,
            title: (
              <span>
                <FormattedMessage id='USERS_ADD_FROM_FILE' />
                <HiddenFileInput
                  accept='text/plain, .csv'
                  onChange={this.handleFileInputChange}
                />
              </span>
            ),
            style: {
              position: 'relative',
              overflow: 'hidden'
            }
          }]]}
          menu={menu.length > 0 ? menu : undefined}
        >
          <div className={classes.flexWrapper}>
            <Tabs
              tabs={tabs}
              defaultSelectedTabId={mode}
              className={classes.tabs}
              tabContainerProps={{
                style: {
                  padding: '0 10px'
                }
              }}
            />
            <div className={classes.searchWrapper}>
              <FormattedMessage id='USERS_SEARCH_HINT'>
                {formattedMessage =>
                  <FormControl
                    type='text'
                    defaultValue={keyword}
                    placeholder={formattedMessage}
                    onChange={this.handleSearchInputChange}
                  />
                }
              </FormattedMessage>
            </div>
            <Scrollbars
              className={classes.usersWrapper}
            >
              <ul className='list-group'>
                {users.map(user =>
                  <HomeUser
                    key={user.id}
                    id={user.id}
                    currentUserRoles={currentUserRoles}
                    mode={mode}
                    permissionLevel={user.permissionLevel}
                    onActivateUser={this.handleActivateUser}
                    onDeactivateUser={this.handleDeactivateUser}
                    onRolesClick={this.handleRolesClick}
                  />
                )}
              </ul>
              {loading &&
                <Loader center />
              }
              {(!loaded && !loading) &&
                <Waypoint
                  key={mode + '-' + lastLoadedId}
                  onEnter={this.handleWaypointEnter}
                  bottomOffset='-50%'
                />
              }
            </Scrollbars>
          </div>
        </LeftSidebarView>
        {addingUserToKanBo &&
          <Modal onClose={this.closeAddUser}>
            <LeftSidebarView
              title={<FormattedMessage id='USERS_ADD' />}
            >
              <div className={classes.flexWrapper}>
                <div className={classes.searchWrapper}>
                  <FormattedMessage id='USERS_SEARCH_HINT'>
                    {formattedMessage =>
                      <FormControl
                        type='text'
                        value={spUsersKeyword}
                        placeholder={formattedMessage}
                        onChange={this.handleAddUserSearchInputChange}
                      />
                    }
                  </FormattedMessage>
                </div>
                <Scrollbars
                  className={classes.userPickerWrapper}
                >
                  <SPUserPicker
                    ref={this.setUserPickerRef}
                    keyword={spUsersKeyword}
                  />
                </Scrollbars>
                <div className={classes.buttonsWrapper}>
                  <ButtonGroup>
                    <Button
                      bsStyle='primary'
                      icon={<KanBoIcon fixedWidth name='kanbo-16-plus' />}
                      onClick={this.handleAddUserClick}
                    >
                      <FormattedMessage id='ADD_SELECTED' />
                    </Button>
                    <Button onClick={this.closeAddUser}>
                      <FormattedMessage id='CANCEL' />
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            </LeftSidebarView>
          </Modal>
        }
      </React.Fragment>
    )
  }
}

export default withLeftSidebar(Users)
